export default {
  form: {
    header: {
      label: 'Kopfzeile',
      placeholder: 'Kopfzeile',
    },
    sub_header: {
      label: 'Unter Kopfzeile',
      placeholder: 'Unter Kopfzeile',
    },
    description: {
      label: 'Beschreibung',
      placeholder: 'Beschreibung',
    },
    qr_code_header: {
      label: 'UI-Box-Kopfzeile',
      placeholder: 'UI-Box-Kopfzeile',
    },
    qr_code_description: {
      label: 'UI box Beschreibung',
      placeholder: 'UI box Beschreibung',
    },
    footer: {
      label: 'Text in der Fußzeile',
      placeholder: 'Fußzeilentext eingeben',
    },
    url_type: {
      label: 'URL',
      placeholder: 'URL auswählen',
    },
    url: {
      placeholder: 'www.example.com',
    },
    primary_color: {
      label: 'Primäre Farbe',
    },
    background_color: {
      label: 'Hintergrundfarbe',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Flugblatt konnte nicht geladen werden',
  },
};
